import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const getCategoryById = createAsyncThunk('category/getCategoryById', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/category/${id}`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getAllCategories = createAsyncThunk('category/getAllCategories', async (params, thunkAPI) => {
  const { page = 1, search, sortBy, sortOrder, useGroupAirportPackage, limit = 20, showVehicle } = params;

  let newUrl = `/category?limit=${limit}&page=${page}`;

  if (search) {
    newUrl += `&search=${search}`;
  }

  if (sortBy) {
    newUrl += `&sort_by=${sortBy}`;
  }

  if (sortOrder) {
    newUrl += `&sort_order=${sortOrder}`;
  }

  if (useGroupAirportPackage) {
    newUrl += `&use_group_airport_package=${useGroupAirportPackage}`;
  }

  if (showVehicle) {
    newUrl += `&show_vehicle=${showVehicle}`;
  }

  try {
    const response = await axiosInstance.get(newUrl);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const createCategory = createAsyncThunk('category/createCategory', async (payload, thunkAPI) => {
  try {
    const response = await axiosInstance.post(`/category`, payload);

    thunkAPI.dispatch(getAllCategories({ page: 1 }));

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const editCategory = createAsyncThunk('category/editCategorye', async ({ payload, id }, thunkAPI) => {
  try {
    const response = await axiosInstance.put(`/category/${id}`, { ...payload });

    thunkAPI.dispatch(getAllCategories({ page: 1 }));

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const deleteCategory = createAsyncThunk('category/deleteCategory', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.delete(`/category/${id}`);

    thunkAPI.dispatch(getAllCategories({ page: 1 }));
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getVehicleByCategory = createAsyncThunk('category/getVehicleByCategory', async (page = 1, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/category?&page=${page}&show_vehicle=true`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getSearchVehicleByCategory = createAsyncThunk(
  'category/getSearchVehicleByCategory',
  async ({ page = 1, search }, thunkAPI) => {
    let mainUrl = `/category?&page=${page}&show_vehicle=true`;

    if (search) {
      mainUrl += `&search=${search}`;
    }

    try {
      const response = await axiosInstance.get(mainUrl);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);
